import styled from 'styled-components';
import {memo, ReactChild} from 'react';

const OverlayWrapper = styled.div<{$leftOffset?: number}>`
  z-index: 3;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 1px;
  width: ${({$leftOffset}) => ($leftOffset ? 'auto' : '100%')};
  position: fixed;
  background: rgba(39, 50, 64, 0.6);
  will-change: opacity;
  top: 0;
  bottom: 0;
  right: ${({$leftOffset}) => ($leftOffset ? 0 : 'auto')};
  left: ${({$leftOffset}) =>
    $leftOffset ? `${$leftOffset}px` : '50%'};
  transform: ${({$leftOffset}) =>
    $leftOffset ? 'none' : 'translateX(-50%)'};
`;

export const Overlay = memo(
  ({children, leftOffset}: {children: ReactChild; leftOffset?: number}) => {
    return (
      <OverlayWrapper $leftOffset={leftOffset}>{children}</OverlayWrapper>
    );
  },
);

Overlay.displayName = 'Overlay';
